/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {Meta,Notify} from 'quasar'



export default { config: {"brand":{"secondary":"#ff7700","accent":"#9C27B0","dark":"#2e3e54","dark-page":"#3e5370","positive":"#21BA45","negative":"#C10015","info":"#31CCEC","warning":"#F2C037"},"notify":{"position":"top"}},plugins: {Meta,Notify} }

